import { Reducer } from 'redux';
import { IChartState } from './types';

const INITIAL_STATE: IChartState = {
  charts: [],
};
const chart: Reducer<IChartState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ADD_CHART_TO_EXPORT': {
      const { charts } = action.payload.charts;

      return {
        charts,
      };
    }
    default: {
      return state;
    }
  }
};

export default chart;
